import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Typography,
    withStyles,
    Radio,
    Grid,
    TextField,
    MenuItem,
} from 'material-ui';
import 'cropperjs/dist/cropper.css';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import ImageCropper from '../../../components/image/cropper';
import {styles} from '../style/image_details';
import ImageMetaFields from './image_meta_fields';

class ImageDetailsCrop extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expandedCrop: false,
            expandedCropSquare: false,
            expandedMeta: false,
            visibleCrop: false,
            selectedValue: '',
            selectedRatioId: '',
        };
    }

    static defaultProps = {
        displayAllRatios: true,
    };

    selectRadio = (ratio) => {
        if (ratio === 'crop' || 'cropLarge') {
            this.setState({
                visibleCrop: true,
                selectedValue: ratio,
            });
        }

        this.props.clearCroppedResult();
    };

    selectRatio = (ratioId) => {
        let selectedRatioValue = {width: 1, height: 1};

        const {imageRatios} = this.props;

        Object.keys(imageRatios).map((id, index) => {
            if (id === ratioId) {
                let ratioValue = Object.values(imageRatios)[index];

                selectedRatioValue = {
                    width: ratioValue.width,
                    height: ratioValue.height,
                };
            }

            return selectedRatioValue;
        });

        this.setState({
            selectedRatioId: ratioId,
            selectedValue: selectedRatioValue,
            visibleCrop: true,
        });

        this.props.setCropRatioId(parseInt(ratioId, 10));
    };

    handleClosePopUp = () => {
        this.setState({
            visibleCrop: false,
            expandedCropSquare: false,
            selectedValue: '',
        });
        this.props.handleClose();
    };

    render() {
        const {
            open,
            handleClose,
            handleSubmit,
            imageToCrop,
            classes,
            imageRatios,
            cropResult,
            thumbCropResult,
            isHero,
        } = this.props;

        if (!imageToCrop) {
            return null;
        }

        let isNormalCrop = this.state.selectedValue === 'crop';

        return (
            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen
                classes={{
                    paper: classes.paper,
                }}
            >
                <DialogTitle>Image Details</DialogTitle>

                <DialogContent>
                    {this.props.displayAllRatios && (
                        <Grid>
                            <Typography className={classes.heading}>
                                Crop Image
                            </Typography>
                            <TextField
                                id="faqs-types"
                                value={this.state.selectedRatioId || -1}
                                onChange={(event) =>
                                    this.selectRatio(event.target.value)
                                }
                                select
                                label=""
                                className={classes.textField}
                                margin="normal"
                            >
                                <MenuItem
                                    key={-1}
                                    value={-1}
                                    className={classes.selectMenuItemFilters}
                                >
                                    {' '}
                                    - please select crop ratio -{' '}
                                </MenuItem>
                                {Object.keys(imageRatios).map((id, index) => {
                                    const ratioObj = Object.values(imageRatios);
                                    const ratio = ratioObj[index];
                                    return (
                                        <MenuItem
                                            key={id}
                                            value={id}
                                            className={
                                                classes.selectMenuItemFilters
                                            }
                                        >
                                            {ratio.name}
                                        </MenuItem>
                                    );
                                })}
                            </TextField>

                            {this.state.visibleCrop && (
                                <ExpansionPanel
                                    expanded={true}
                                    onChange={(event, expanded) => {
                                        this.setState({
                                            expandedCrop: expanded,
                                        });
                                    }}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography className={classes.heading}>
                                            Crop Image (
                                            {this.state.selectedValue.width}:
                                            {this.state.selectedValue.height})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <ImageCropper
                                            autoCropArea={0.95}
                                            ratioWidth={
                                                this.state.selectedValue.width
                                            }
                                            ratioHeight={
                                                this.state.selectedValue.height
                                            }
                                            imageToCrop={imageToCrop}
                                            setCropResult={
                                                this.props.setCropResult
                                            }
                                            cropResult={cropResult}
                                            cropBoxResizable={true}
                                            index={1}
                                        />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            )}
                        </Grid>
                    )}

                    {!this.props.displayAllRatios && isHero && (
                        <Grid container spacing={0}>
                            {Object.keys(imageRatios)
                                .slice(0, 2)
                                .map((ratio, index) => {
                                    let ratioValue = Object.values(imageRatios)[
                                        index
                                    ];

                                    return (
                                        <Grid item xs={6} key={index}>
                                            <Typography>
                                                Crop Image ({ratioValue.width}:{' '}
                                                {ratioValue.height})
                                            </Typography>
                                            <Radio
                                                onChange={() =>
                                                    this.selectRadio(ratio)
                                                }
                                                checked={
                                                    this.state.selectedValue ===
                                                    ratio
                                                }
                                                value={ratio}
                                            />
                                        </Grid>
                                    );
                                })}
                        </Grid>
                    )}
                    {!this.props.displayAllRatios &&
                        isHero &&
                        this.state.visibleCrop && (
                            <React.Fragment>
                                <ExpansionPanel
                                    expanded={this.state.expandedCrop}
                                    onChange={(event, expanded) => {
                                        this.setState({
                                            expandedCrop: expanded,
                                        });
                                    }}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography className={classes.heading}>
                                            Crop Image (
                                            {isNormalCrop
                                                ? imageRatios.crop.width
                                                : imageRatios.cropLarge.width}
                                            :{' '}
                                            {isNormalCrop
                                                ? imageRatios.crop.height
                                                : imageRatios.cropLarge.height}
                                            )
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <ImageCropper
                                            autoCropArea={0.95}
                                            ratioWidth={
                                                isNormalCrop
                                                    ? imageRatios.crop.width
                                                    : imageRatios.cropLarge
                                                          .width
                                            }
                                            ratioHeight={
                                                isNormalCrop
                                                    ? imageRatios.crop.height
                                                    : imageRatios.cropLarge
                                                          .height
                                            }
                                            imageToCrop={imageToCrop}
                                            setCropResult={
                                                this.props.setCropResult
                                            }
                                            cropResult={cropResult}
                                            cropBoxResizable={true}
                                            index={1}
                                        />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel
                                    disabled={
                                        imageRatios.crop.width ===
                                        imageRatios.crop.height
                                    }
                                    expanded={this.state.expandedCropSquare}
                                    onChange={(event, expanded) => {
                                        this.setState({
                                            expandedCropSquare: expanded,
                                        });
                                    }}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography className={classes.heading}>
                                            Crop Image Thumb (
                                            {imageRatios.cropThumb.width}:
                                            {imageRatios.cropThumb.height})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <ImageCropper
                                            autoCropArea={0.8}
                                            ratioWidth={
                                                imageRatios.cropThumb.width
                                            }
                                            ratioHeight={
                                                imageRatios.cropThumb.height
                                            }
                                            imageToCrop={imageToCrop}
                                            setCropResult={
                                                this.props.setThumbCropResult
                                            }
                                            cropResult={thumbCropResult}
                                            cropBoxResizable={true}
                                            index={3}
                                        />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </React.Fragment>
                        )}
                    {!this.props.displayAllRatios && !isHero && (
                        <React.Fragment>
                            <ExpansionPanel
                                expanded={this.state.expandedCrop}
                                onChange={(event, expanded) => {
                                    this.setState({
                                        expandedCrop: expanded,
                                    });
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography className={classes.heading}>
                                        Crop Image ({imageRatios.crop.width}:
                                        {imageRatios.crop.height})
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <ImageCropper
                                        autoCropArea={0.95}
                                        ratioWidth={imageRatios.crop.width}
                                        ratioHeight={imageRatios.crop.height}
                                        imageToCrop={imageToCrop}
                                        setCropResult={this.props.setCropResult}
                                        cropResult={cropResult}
                                        cropBoxResizable={true}
                                        index={1}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            <ExpansionPanel
                                disabled={
                                    imageRatios.crop.width ===
                                    imageRatios.crop.height
                                }
                                expanded={this.state.expandedCropSquare}
                                onChange={(event, expanded) => {
                                    this.setState({
                                        expandedCropSquare: expanded,
                                    });
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography className={classes.heading}>
                                        Crop Image Thumb (
                                        {imageRatios.cropThumb.width}:
                                        {imageRatios.cropThumb.height})
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <ImageCropper
                                        autoCropArea={0.8}
                                        ratioWidth={imageRatios.cropThumb.width}
                                        ratioHeight={
                                            imageRatios.cropThumb.height
                                        }
                                        imageToCrop={imageToCrop}
                                        setCropResult={
                                            this.props.setThumbCropResult
                                        }
                                        cropResult={thumbCropResult}
                                        cropBoxResizable={true}
                                        index={2}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}

                    <ExpansionPanel
                        expanded={this.state.expandedMeta}
                        onChange={(event, expanded) => {
                            this.setState({
                                expandedMeta: expanded,
                            });
                        }}
                    >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={classes.heading}>
                                Image Meta Info
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <ImageMetaFields
                                classes={this.props.classes}
                                imageMeta={this.props.imageMeta}
                                setAltField={this.props.setAltField}
                                setTitleField={this.props.setTitleField}
                                setNameField={this.props.setNameField}
                                setDescriptionField={
                                    this.props.setDescriptionField
                                }
                                setLinkField={this.props.setLinkField}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        onClick={this.handleClosePopUp}
                        variant="raised"
                        className={classes.button}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleSubmit()}
                        color="primary"
                        variant="raised"
                        className={classes.button}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(ImageDetailsCrop);



// WEBPACK FOOTER //
// ./src/containers/builder/form/image_details_crop.js